<sbnb-signup-wizard-template>
  <ng-container left-side>
    <h1 class="text-2xl md:text-3xl mb-8">Welcome home!</h1>

    <ng-container *ngIf="!isAirbnbSignup">
      <p class="mb-6">We are excited to start helping you save time and deliver a better guest experience.</p>

      <p>
        To make the best use of your trial period, we recommend you start by connecting your
        {{ platform | titlecase }} account.
      </p>

      <sbnb-button class="block mt-8" [fullWidth]="true" [loading]="loading" (clicked)="onContinue()">
        Connect with {{ platform | titlecase }}
      </sbnb-button>

      <div class="w-full text-center">
        <a
          mat-button
          class="text-sm text-night"
          [ngClass]="loading ? 'pointer-events-none opacity-50' : ''"
          (click)="onContinue('onboarding')">
          I'll do it later
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="isAirbnbSignup">
      <p class="mb-6">
        We are excited for you and your guests to start benefiting from our state-of-the-art technology and time-saving
        features.
      </p>

      <sbnb-button [fullWidth]="true" [loading]="loading" (clicked)="onContinue()">
        Get started with the basics
      </sbnb-button>
    </ng-container>
  </ng-container>

  <img right-side src="/assets/images/signup/done.svg" />
</sbnb-signup-wizard-template>

<img src="https://ct.capterra.com/capterra_tracker.gif?vid=2132563&vkey=1e99854893385b6328e80d70b1cd00e3" />
